export default __webpack_public_path__ + "static/media/pw.a444c53f.PNG";